import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import ButtonPrimary from '../../components/buttons/ButtonPrimary';

export const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        try {
            const response = await fetch('/api/auth/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword }),
            });

            const data = await response.json();
            if (response.ok) {
                toast.success(data.message);
                setIsSubmitted(true);
                setTimeout(() => navigate('/login'), 15000); // Auto-redirect after 3 seconds
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('An error occurred. Please try again.');
        }
    };

    return (
        <div className="landing-page">
            <ToastContainer />

            <div className="back-home-link">
                <Link to="/">← Back to home</Link>
            </div>

            {/* First Part */}
            <div className="top-section text-center">
                <form id="reset-password-form" className="show" onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-12">
                            <span id="login-title">Reset Password</span>
                        </div>
                    </div>

                    <div className="row margin-btm-30">
                        <div className="col-12">
                            <span className="icon textbox-icon-container">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="icon icon-tabler icon-tabler-lock"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1"
                                    stroke="#000000"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <rect x="5" y="11" width="14" height="10" rx="2" />
                                    <circle cx="12" cy="16" r="1" />
                                    <path d="M8 11v-4a4 4 0 0 1 8 0v4" />
                                </svg>
                            </span>
                            <input
                                className="form-control fillet-text-box text-box-with-icon"
                                type="password"
                                placeholder="New Password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className="row margin-btm-30">
                        <div className="col-12">
                            <span className="icon textbox-icon-container">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="icon icon-tabler icon-tabler-lock"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1"
                                    stroke="#000000"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <rect x="5" y="11" width="14" height="10" rx="2" />
                                    <circle cx="12" cy="16" r="1" />
                                    <path d="M8 11v-4a4 4 0 0 1 8 0v4" />
                                </svg>
                            </span>
                            <input
                                className="form-control fillet-text-box text-box-with-icon"
                                type="password"
                                placeholder="Confirm New Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    {isSubmitted ? (
                        <div className="row margin-btm-30">
                            <div className="col-12">
                                <p className="success-message">
                                    Your password has been successfully reset. <br/> Redirecting to login after 15 seconds...
                                </p>
                            </div>
                        </div>
                    ) : (
                        <ButtonPrimary className="margin-btm-15" type="submit" value="Reset Password" />
                    )}

                    <div className="row margin-btm-15">
                        <div className="col-12">
                            <span>
                                Remembered your password?{' '}
                                <span className="bold signup-toggle-btn" onClick={() => navigate('/login')}>
                                    Back to Login
                                </span>
                            </span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
